import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { EditActionContext } from "./EditActionContext";

function useGet() {
  const {
    setElement,
    setShowModal,
    setSelectedLang,
    setBackendFormErrors,
    setCommercePrice,
    setShippingPercentage,
    setCommissionPercentage,
  } = useContext(EditActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    setBackendFormErrors({});
    get("combinations", id, "?relations=attributes,attributes.options")
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setElement(data);
        setCommercePrice(data.price);
        setShippingPercentage(data.shipment_percentage);
        setCommissionPercentage(data.commission_percentage);
        setSelectedLang("es");
        setShowModal(true);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
